import { Router, UrlTree } from '@angular/router';

import { APPOINTMENT_ROUTES } from '../consts/appointment-routes.const';
import { isValidDealerId } from './dealer-id';

const DEALER_ID_PARAM = 'dealerId';

/**
 * Reads a validated `dealerId` out of a URL string (the URL we are leaving/targeting).
 * Returns null when absent or malformed.
 */
export function dealerIdFromUrl(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }
  const query: string = url.split('?')[1] ?? '';
  const value: string | null = new URLSearchParams(query).get(DEALER_ID_PARAM);
  return value && isValidDealerId(value) ? value : null;
}

/**
 * UrlTree to the start page that keeps `?dealerId=` alive. Redirects to start (auth-guard
 * bounce, 401 interceptor, logout) otherwise drop the param, which trips app.ts's
 * "missing dealer" gate. `dealerId` is whatever is available at redirect time — typically
 * the URL being left or the navigation being blocked.
 */
export function startRedirectUrlTree(router: Router, dealerId: string | null | undefined): UrlTree {
  const tree: UrlTree = router.parseUrl(APPOINTMENT_ROUTES.REDIRECT_URL);
  if (dealerId && isValidDealerId(dealerId)) {
    tree.queryParams = { ...tree.queryParams, [DEALER_ID_PARAM]: dealerId };
  }
  return tree;
}
